import React from 'react';

import PropTypes from 'prop-types';

export default function FeaturesSlice(props) {
    const {
        headline,
        features
    } = props.data;

    return (
// columns subbed by flexbox
        <section id="features" className="features-block">
            <div className="container">
                {headline && <h3 className="h3">{headline}</h3>}
                <div className="row flex-container">
                    {features && features.map((feature, index) => (
                        <div className="flex-column" key={index}>
                            <div className="features-block_container">
                                <div className="features-block_icon">
                                    <div className="hexagon gradient"></div>
                                    <img src={feature.icon} alt={feature.title} />
                                </div>
                                <div className="features-block_content">
                                    <h4 className="h4">{feature.title}</h4>
                                    <p className="p-tag">{feature.description}</p>
                                    {feature.link &&
                                        <a href={feature.link}>> Learn More</a>
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

FeaturesSlice.propTypes = {
    data: PropTypes.shape({
        headline: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.object)
    }),
}



// WEBPACK FOOTER //
// src/client/components/slices/FeaturesSlice.js